import { NotificationSwitcher } from '@core/model/framework/notifications/notificationSwitcher';
import {
  WaitOnBankAccountAnalysisCompletionGateway,
  WaitOnBankAccountAnalysisCompletionGatewayInput,
  WaitOnBankAccountAnalysisCompletionGatewayOutput,
} from '@core/model/gateway/waitOnBankAccountAnalysisCompletionGateway';
import { inject, injectable } from 'inversify';

@injectable()
export class WaitOnBankAccountAnalysisCompletionSwitcher
  implements WaitOnBankAccountAnalysisCompletionGateway
{
  constructor(@inject(NotificationSwitcher) private notificationSwitcher: NotificationSwitcher) {}

  async await(
    input: WaitOnBankAccountAnalysisCompletionGatewayInput
  ): WaitOnBankAccountAnalysisCompletionGatewayOutput {
    return await this.notificationSwitcher
      .getWaitOnBankAccountAnalysisCompletionNotificationGateway()
      .await(input);
  }

  stop() {
    return this.notificationSwitcher.getWaitOnBankAccountAnalysisCompletionNotificationGateway().stop();
  }
}
